// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hostSearchOption{
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}
.compactHostSelector{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 70%;
}
.compactHostSelectorAdmin{
    position: relative;
    display: block;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 70%;
}
.labelHostSelector{
    /* font-weight: bold; */
    position: absolute;
    top: -20%;
    /* color: #eaeaea; */
    
    color:  #c4c4c4;
}
.react-host-select__control{
    border-color: var(--border-table-color) !important;
    /* border-color: #ee085c; */
    min-height: unset !important;
width: 100%;
height: 100% !important;
/* border-top: none !important;
border-left: none !important; */
border-radius: 5px;
background-color: var(--white-color) !important;
color: var(--txt-color) !important;

letter-spacing: 1px;
 text-align: center;
}
.react-host-select__control .react-host-select__control--is-fo_{
    width: 100%;
height: 100% !important;
}
.react-host-select__control .react-host-select__control--menu-is-open{
    width: 100%;
height: 100% !important;
min-height: unset !important;
}

.react-host-select__input,.react-host-select__placeholder{
    background-color: transparent !important;
    color:  var(--txt-color)  !important;
    border: none !important;
    outline: 0 !important;
}
.react-host-select-container{
    outline: 0 !important;
    /* top: -4px; */
    width: 85%;
    height: 100%;
}
.react-host-select-container-admin{
    background: #FFF !important;
    color: #003757;
}
.react-host-select__input-container,.react-host-select__single-value {
    color: var(--txt-color) !important;
    font-size: x-small;
}

.react-host-select__indicator svg{
    color: var(--txt-color) ;
 }
 .react-host-select__indicator-separator{
    margin-bottom: unset !important;
  margin-top: unset !important;
  /* box-sizing: border-box; */
  top: unset !important;
  position: relative;
 }
 .react-host-select__indicators{
    height: 100%;
 }
 
.react-host-select__indicator .react-host-select__dropdown-indicator{
    width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
.react-host-select__menu:hover{
    cursor: pointer;
}
.react-host-select__menu{
    /* border-color:#088eee !important;; */
    background-color:var(--white-color) !important ;
    color: var(--txt-color) !important;
    border: 1px solid aliceblue !important;
    align-items: center !important;
    display: flex !important;
    text-align: center !important;
    cursor: pointer;
    z-index: 4;
    font-size: x-small;
}
.react-host-select__menu-list{
    width: 100% !important;
}
.react-host-select__option{
    border-bottom-color: rgba(255, 255, 255, 0.127) !important;
}
/***************************** SELECTOR ADMIN **************************************/

.react-host-select-admin__control{
    border-color: #003757 !important;
    /* border-color: #ee085c; */
width: 100%;
height: 100%;
border-top: none !important;
border-left: none !important;
border-radius: 5px;
border-width: 2px !important;
/* background-color: #00000029 !important; */
color: #003757 !important;

letter-spacing: 1px;
 text-align: left;
}
.react-host-select-admin__input,.react-host-select-admin__placeholder{
    background-color: transparent !important;
    color: #003757 !important;
    border: none !important;
    /* outline: 0 !important; */
    font-size: large !important;
}
.react-host-select-container-admin{
    outline: 0 !important;
    /* top: 5px; */
}

.react-host-select-admin__input-container,.react-host-select-admin__single-value {
    color: #003757 !important;
}
.react-host-select-admin__indicator svg{
    color: #003757 ;
 }


.react-host-select-admin__menu:hover{
    cursor: pointer;
}
.react-host-select-admin__menu{
    border-color:#003757 !important;;
    background-color:aliceblue !important ;
    color: #003757 !important;
    border: 1px solid aliceblue !important;
    align-items: center !important;
    display: flex !important;
    text-align: center !important;
    cursor: pointer;
}
.react-host-select-admin__menu-list{
    width: 100% !important;
}
.react-host-select-admin__option{
    border-bottom-color: rgba(255, 255, 255, 0.127) !important;
}

/******************************/
.Whitereact-host-select__control{
    border-color: #b3b3b3 !important;
    /* border-color: #ee085c; */
width: 100%;
height: 100%;
border-top: none !important;
border-left: none !important;
border-radius: 5px;
background-color: #00000029 !important;
color: aliceblue !important;

letter-spacing: 1px;
 text-align: center;
}
.Whitereact-host-select__input,.Whitereact-host-select__placeholder{
    background-color: transparent !important;
    color: aliceblue !important;
    border: none !important;
    outline: 0 !important;
}
.Whitereact-host-select-container{
    outline: 0 !important;
    top: -4px;
}
.Whitereact-host-select-container-admin{
    background: #FFF !important;
    color: #003757;
}
.Whitereact-host-select__input-container,.Whitereact-host-select__single-value {
    color: #003757 !important;
    font-size: x-small;
}

.Whitereact-host-select__indicator svg{
    color: #088eee ;
 }


.Whitereact-host-select__menu:hover{
    cursor: pointer;
}
.Whitereact-host-select__menu{
    border-color:#088eee !important;;
    background-color:#030915 !important ;
    color: #088eee !important;
    border: 1px solid aliceblue !important;
    align-items: center !important;
    display: flex !important;
    text-align: center !important;
    cursor: pointer;
    z-index: 4;
    font-size: x-small;
}
.Whitereact-host-select__menu-list{
    width: 100% !important;
}
.Whitereact-host-select__option{
    border-bottom-color: rgba(255, 255, 255, 0.127) !important;
}
/***************************** SELECTOR ADMIN **************************************/

.Whitereact-host-select-admin__control{
    border-color: #003757 !important;
    /* border-color: #ee085c; */
width: 100%;
height: 100%;
border-top: none !important;
border-left: none !important;
border-radius: 5px;
border-width: 2px !important;
/* background-color: #00000029 !important; */
color: #003757 !important;

letter-spacing: 1px;
 text-align: left;
}
.Whitereact-host-select-admin__input,.Whitereact-host-select-admin__placeholder{
    background-color: transparent !important;
    color: #003757 !important;
    border: none !important;
    /* outline: 0 !important; */
    font-size: large !important;
}
.Whitereact-host-select-container-admin{
    outline: 0 !important;
    /* top: 5px; */
}

.Whitereact-host-select-admin__input-container,.Whitereact-host-select-admin__single-value {
    color: #003757 !important;
}
.Whitereact-host-select-admin__indicator svg{
    color: #003757 ;
 }


.Whitereact-host-select-admin__menu:hover{
    cursor: pointer;
}
.Whitereact-host-select-admin__menu{
    border-color:#003757 !important;;
    background-color:aliceblue !important ;
    color: #003757 !important;
    border: 1px solid aliceblue !important;
    align-items: center !important;
    display: flex !important;
    text-align: center !important;
    cursor: pointer;
}
.Whitereact-host-select-admin__menu-list{
    width: 100% !important;
}
.Whitereact-host-select-admin__option{
    border-bottom-color: rgba(255, 255, 255, 0.127) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/HostSelector.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;AACA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,oBAAoB;;IAEpB,eAAe;AACnB;AACA;IACI,kDAAkD;IAClD,2BAA2B;IAC3B,4BAA4B;AAChC,WAAW;AACX,uBAAuB;AACvB;+BAC+B;AAC/B,kBAAkB;AAClB,+CAA+C;AAC/C,kCAAkC;;AAElC,mBAAmB;CAClB,kBAAkB;AACnB;AACA;IACI,WAAW;AACf,uBAAuB;AACvB;AACA;IACI,WAAW;AACf,uBAAuB;AACvB,4BAA4B;AAC5B;;AAEA;IACI,wCAAwC;IACxC,oCAAoC;IACpC,uBAAuB;IACvB,qBAAqB;AACzB;AACA;IACI,qBAAqB;IACrB,eAAe;IACf,UAAU;IACV,YAAY;AAChB;AACA;IACI,2BAA2B;IAC3B,cAAc;AAClB;AACA;IACI,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;CAC3B;CACA;IACG,+BAA+B;EACjC,4BAA4B;EAC5B,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;CACnB;CACA;IACG,YAAY;CACf;;AAED;IACI,WAAW;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;IACI,eAAe;AACnB;AACA;IACI,sCAAsC;IACtC,+CAA+C;IAC/C,kCAAkC;IAClC,sCAAsC;IACtC,8BAA8B;IAC9B,wBAAwB;IACxB,6BAA6B;IAC7B,eAAe;IACf,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,0DAA0D;AAC9D;AACA,oFAAoF;;AAEpF;IACI,gCAAgC;IAChC,2BAA2B;AAC/B,WAAW;AACX,YAAY;AACZ,2BAA2B;AAC3B,4BAA4B;AAC5B,kBAAkB;AAClB,4BAA4B;AAC5B,4CAA4C;AAC5C,yBAAyB;;AAEzB,mBAAmB;CAClB,gBAAgB;AACjB;AACA;IACI,wCAAwC;IACxC,yBAAyB;IACzB,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;AAC/B;AACA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,eAAe;CAClB;;;AAGD;IACI,eAAe;AACnB;AACA;IACI,+BAA+B;IAC/B,sCAAsC;IACtC,yBAAyB;IACzB,sCAAsC;IACtC,8BAA8B;IAC9B,wBAAwB;IACxB,6BAA6B;IAC7B,eAAe;AACnB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,0DAA0D;AAC9D;;AAEA,+BAA+B;AAC/B;IACI,gCAAgC;IAChC,2BAA2B;AAC/B,WAAW;AACX,YAAY;AACZ,2BAA2B;AAC3B,4BAA4B;AAC5B,kBAAkB;AAClB,sCAAsC;AACtC,2BAA2B;;AAE3B,mBAAmB;CAClB,kBAAkB;AACnB;AACA;IACI,wCAAwC;IACxC,2BAA2B;IAC3B,uBAAuB;IACvB,qBAAqB;AACzB;AACA;IACI,qBAAqB;IACrB,SAAS;AACb;AACA;IACI,2BAA2B;IAC3B,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,eAAe;CAClB;;;AAGD;IACI,eAAe;AACnB;AACA;IACI,+BAA+B;IAC/B,oCAAoC;IACpC,yBAAyB;IACzB,sCAAsC;IACtC,8BAA8B;IAC9B,wBAAwB;IACxB,6BAA6B;IAC7B,eAAe;IACf,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,0DAA0D;AAC9D;AACA,oFAAoF;;AAEpF;IACI,gCAAgC;IAChC,2BAA2B;AAC/B,WAAW;AACX,YAAY;AACZ,2BAA2B;AAC3B,4BAA4B;AAC5B,kBAAkB;AAClB,4BAA4B;AAC5B,4CAA4C;AAC5C,yBAAyB;;AAEzB,mBAAmB;CAClB,gBAAgB;AACjB;AACA;IACI,wCAAwC;IACxC,yBAAyB;IACzB,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;AAC/B;AACA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,eAAe;CAClB;;;AAGD;IACI,eAAe;AACnB;AACA;IACI,+BAA+B;IAC/B,sCAAsC;IACtC,yBAAyB;IACzB,sCAAsC;IACtC,8BAA8B;IAC9B,wBAAwB;IACxB,6BAA6B;IAC7B,eAAe;AACnB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,0DAA0D;AAC9D","sourcesContent":[".hostSearchOption{\r\n    display: flex;\r\n    position: relative;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n.compactHostSelector{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 70%;\r\n}\r\n.compactHostSelectorAdmin{\r\n    position: relative;\r\n    display: block;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 70%;\r\n}\r\n.labelHostSelector{\r\n    /* font-weight: bold; */\r\n    position: absolute;\r\n    top: -20%;\r\n    /* color: #eaeaea; */\r\n    \r\n    color:  #c4c4c4;\r\n}\r\n.react-host-select__control{\r\n    border-color: var(--border-table-color) !important;\r\n    /* border-color: #ee085c; */\r\n    min-height: unset !important;\r\nwidth: 100%;\r\nheight: 100% !important;\r\n/* border-top: none !important;\r\nborder-left: none !important; */\r\nborder-radius: 5px;\r\nbackground-color: var(--white-color) !important;\r\ncolor: var(--txt-color) !important;\r\n\r\nletter-spacing: 1px;\r\n text-align: center;\r\n}\r\n.react-host-select__control .react-host-select__control--is-fo_{\r\n    width: 100%;\r\nheight: 100% !important;\r\n}\r\n.react-host-select__control .react-host-select__control--menu-is-open{\r\n    width: 100%;\r\nheight: 100% !important;\r\nmin-height: unset !important;\r\n}\r\n\r\n.react-host-select__input,.react-host-select__placeholder{\r\n    background-color: transparent !important;\r\n    color:  var(--txt-color)  !important;\r\n    border: none !important;\r\n    outline: 0 !important;\r\n}\r\n.react-host-select-container{\r\n    outline: 0 !important;\r\n    /* top: -4px; */\r\n    width: 85%;\r\n    height: 100%;\r\n}\r\n.react-host-select-container-admin{\r\n    background: #FFF !important;\r\n    color: #003757;\r\n}\r\n.react-host-select__input-container,.react-host-select__single-value {\r\n    color: var(--txt-color) !important;\r\n    font-size: x-small;\r\n}\r\n\r\n.react-host-select__indicator svg{\r\n    color: var(--txt-color) ;\r\n }\r\n .react-host-select__indicator-separator{\r\n    margin-bottom: unset !important;\r\n  margin-top: unset !important;\r\n  /* box-sizing: border-box; */\r\n  top: unset !important;\r\n  position: relative;\r\n }\r\n .react-host-select__indicators{\r\n    height: 100%;\r\n }\r\n \r\n.react-host-select__indicator .react-host-select__dropdown-indicator{\r\n    width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.react-host-select__menu:hover{\r\n    cursor: pointer;\r\n}\r\n.react-host-select__menu{\r\n    /* border-color:#088eee !important;; */\r\n    background-color:var(--white-color) !important ;\r\n    color: var(--txt-color) !important;\r\n    border: 1px solid aliceblue !important;\r\n    align-items: center !important;\r\n    display: flex !important;\r\n    text-align: center !important;\r\n    cursor: pointer;\r\n    z-index: 4;\r\n    font-size: x-small;\r\n}\r\n.react-host-select__menu-list{\r\n    width: 100% !important;\r\n}\r\n.react-host-select__option{\r\n    border-bottom-color: rgba(255, 255, 255, 0.127) !important;\r\n}\r\n/***************************** SELECTOR ADMIN **************************************/\r\n\r\n.react-host-select-admin__control{\r\n    border-color: #003757 !important;\r\n    /* border-color: #ee085c; */\r\nwidth: 100%;\r\nheight: 100%;\r\nborder-top: none !important;\r\nborder-left: none !important;\r\nborder-radius: 5px;\r\nborder-width: 2px !important;\r\n/* background-color: #00000029 !important; */\r\ncolor: #003757 !important;\r\n\r\nletter-spacing: 1px;\r\n text-align: left;\r\n}\r\n.react-host-select-admin__input,.react-host-select-admin__placeholder{\r\n    background-color: transparent !important;\r\n    color: #003757 !important;\r\n    border: none !important;\r\n    /* outline: 0 !important; */\r\n    font-size: large !important;\r\n}\r\n.react-host-select-container-admin{\r\n    outline: 0 !important;\r\n    /* top: 5px; */\r\n}\r\n\r\n.react-host-select-admin__input-container,.react-host-select-admin__single-value {\r\n    color: #003757 !important;\r\n}\r\n.react-host-select-admin__indicator svg{\r\n    color: #003757 ;\r\n }\r\n\r\n\r\n.react-host-select-admin__menu:hover{\r\n    cursor: pointer;\r\n}\r\n.react-host-select-admin__menu{\r\n    border-color:#003757 !important;;\r\n    background-color:aliceblue !important ;\r\n    color: #003757 !important;\r\n    border: 1px solid aliceblue !important;\r\n    align-items: center !important;\r\n    display: flex !important;\r\n    text-align: center !important;\r\n    cursor: pointer;\r\n}\r\n.react-host-select-admin__menu-list{\r\n    width: 100% !important;\r\n}\r\n.react-host-select-admin__option{\r\n    border-bottom-color: rgba(255, 255, 255, 0.127) !important;\r\n}\r\n\r\n/******************************/\r\n.Whitereact-host-select__control{\r\n    border-color: #b3b3b3 !important;\r\n    /* border-color: #ee085c; */\r\nwidth: 100%;\r\nheight: 100%;\r\nborder-top: none !important;\r\nborder-left: none !important;\r\nborder-radius: 5px;\r\nbackground-color: #00000029 !important;\r\ncolor: aliceblue !important;\r\n\r\nletter-spacing: 1px;\r\n text-align: center;\r\n}\r\n.Whitereact-host-select__input,.Whitereact-host-select__placeholder{\r\n    background-color: transparent !important;\r\n    color: aliceblue !important;\r\n    border: none !important;\r\n    outline: 0 !important;\r\n}\r\n.Whitereact-host-select-container{\r\n    outline: 0 !important;\r\n    top: -4px;\r\n}\r\n.Whitereact-host-select-container-admin{\r\n    background: #FFF !important;\r\n    color: #003757;\r\n}\r\n.Whitereact-host-select__input-container,.Whitereact-host-select__single-value {\r\n    color: #003757 !important;\r\n    font-size: x-small;\r\n}\r\n\r\n.Whitereact-host-select__indicator svg{\r\n    color: #088eee ;\r\n }\r\n\r\n\r\n.Whitereact-host-select__menu:hover{\r\n    cursor: pointer;\r\n}\r\n.Whitereact-host-select__menu{\r\n    border-color:#088eee !important;;\r\n    background-color:#030915 !important ;\r\n    color: #088eee !important;\r\n    border: 1px solid aliceblue !important;\r\n    align-items: center !important;\r\n    display: flex !important;\r\n    text-align: center !important;\r\n    cursor: pointer;\r\n    z-index: 4;\r\n    font-size: x-small;\r\n}\r\n.Whitereact-host-select__menu-list{\r\n    width: 100% !important;\r\n}\r\n.Whitereact-host-select__option{\r\n    border-bottom-color: rgba(255, 255, 255, 0.127) !important;\r\n}\r\n/***************************** SELECTOR ADMIN **************************************/\r\n\r\n.Whitereact-host-select-admin__control{\r\n    border-color: #003757 !important;\r\n    /* border-color: #ee085c; */\r\nwidth: 100%;\r\nheight: 100%;\r\nborder-top: none !important;\r\nborder-left: none !important;\r\nborder-radius: 5px;\r\nborder-width: 2px !important;\r\n/* background-color: #00000029 !important; */\r\ncolor: #003757 !important;\r\n\r\nletter-spacing: 1px;\r\n text-align: left;\r\n}\r\n.Whitereact-host-select-admin__input,.Whitereact-host-select-admin__placeholder{\r\n    background-color: transparent !important;\r\n    color: #003757 !important;\r\n    border: none !important;\r\n    /* outline: 0 !important; */\r\n    font-size: large !important;\r\n}\r\n.Whitereact-host-select-container-admin{\r\n    outline: 0 !important;\r\n    /* top: 5px; */\r\n}\r\n\r\n.Whitereact-host-select-admin__input-container,.Whitereact-host-select-admin__single-value {\r\n    color: #003757 !important;\r\n}\r\n.Whitereact-host-select-admin__indicator svg{\r\n    color: #003757 ;\r\n }\r\n\r\n\r\n.Whitereact-host-select-admin__menu:hover{\r\n    cursor: pointer;\r\n}\r\n.Whitereact-host-select-admin__menu{\r\n    border-color:#003757 !important;;\r\n    background-color:aliceblue !important ;\r\n    color: #003757 !important;\r\n    border: 1px solid aliceblue !important;\r\n    align-items: center !important;\r\n    display: flex !important;\r\n    text-align: center !important;\r\n    cursor: pointer;\r\n}\r\n.Whitereact-host-select-admin__menu-list{\r\n    width: 100% !important;\r\n}\r\n.Whitereact-host-select-admin__option{\r\n    border-bottom-color: rgba(255, 255, 255, 0.127) !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
